import { TagFilled } from "@ant-design/icons";
import { Divider, Flex, Tooltip } from "antd";
import { useMemo } from "react";
import { useSelector } from "../../../util/store/store";
import { IWeatherData } from "../../../util/varibles/interface";
import { xAxis, XAxisId, yAxisBase } from "../../WeatherChart/constants";

export default function LiveWeather({ vesselId }: { vesselId: string }) {
    const data: IWeatherData | undefined = useSelector(state => state.login.weather[vesselId]);
    const list = useMemo(() => {
        const {
            wind_speed = [],
            wind_direction = [],
            gust = [],
            waves_height = [],
            waves_direction = [],
            waves_period = [],
            temp = [],
            sea_temp = [],
        } = data || {};
        const result = [];

        if (wind_speed.length > 0 && wind_direction.length > 0) {
            const { name, yAxisIndex } = xAxis[XAxisId.WindSpeed];
            const { value } = wind_speed[0];
            const { value: subValue } = wind_direction[0];
            const { name: strUnit } = yAxisBase[yAxisIndex];
            result.push({
                name, value, strUnit, sub: { name: "Wind direction", value: subValue }
            })
        }

        if (gust.length > 0) {
            const { name, yAxisIndex } = xAxis[XAxisId.WindGust];
            const { value } = gust[0];
            const { name: strUnit } = yAxisBase[yAxisIndex];
            result.push({ name, value, strUnit })
        }

        if (waves_height.length > 0 && waves_direction.length > 0) {
            const { name, yAxisIndex } = xAxis[XAxisId.WaveHeight];
            const { value } = waves_height[0];
            const { value: subValue } = waves_direction[0];
            const { name: strUnit } = yAxisBase[yAxisIndex];
            result.push({
                name, value, strUnit, sub: { name: "Waves direction", value: subValue }
            })
        }

        if (waves_period.length > 0) {
            const { name, yAxisIndex } = xAxis[XAxisId.WavePeriod];
            const { value } = waves_period[0];
            const { name: strUnit } = yAxisBase[yAxisIndex];
            result.push({ name, value, strUnit })
        }

        if (temp.length > 0) {
            const { name, yAxisIndex } = xAxis[XAxisId.AirTemperature];
            const { value } = temp[0];
            const { name: strUnit } = yAxisBase[yAxisIndex];
            result.push({ name, value, strUnit })
        }

        if (sea_temp.length > 0) {
            const { name, yAxisIndex } = xAxis[XAxisId.SeaTemperature];
            const { value } = sea_temp[0];
            const { name: strUnit } = yAxisBase[yAxisIndex];
            result.push({ name, value, strUnit })
        }
        return result;
    }, [data])

    return <Flex gap={3} align="center" className="h-[28px] max-w-full">
        <TagFilled style={{ transform: "scaleX(-1)", color: 'var(--colorLink)' }} />
        <div className="color-link text-[14px]">Live: </div>
        <Tooltip title={list.map(item => <div key={item.name} className="min-w-[170px] flex justify-between gap-1">
            <span>{item.name}:</span>
            <span> {item.sub ? `${item.sub.value}° - ` : ""} {item.value} {item.strUnit}</span>
        </div>)}>
            <div className="truncate text-[14px]">
                {list.flatMap((item, i) => [
                    !!i ? <Divider key={i} orientation="vertical" style={{ borderColor: "var(--colorMain)" }} /> : null,
                    <span key={item.name}>
                        {item.name}: {item.sub ? `${item.sub.value}° - ` : ""} {item.value} {item.strUnit}
                    </span>
                ])}
            </div>
        </Tooltip>
    </Flex>
}